import { AwardsApi } from '../clients';
import { mapMemberApplication } from '../mappers';
import { withNotFoundAs } from './notFound';

/**
 * Reads one member's application, or null when there is none to show.
 *
 * awards-service keeps three 404s apart — unknown cycle, no membership, no
 * application — and only the last is an ordinary state: an admin can set
 * someone to applicant without an application ever existing. The other two are
 * only reachable from a roster row that has gone stale underneath the page, and
 * "there is nothing to show" is still the honest answer for those, so all three
 * collapse to null and the dialog renders an empty state rather than a failure.
 */
export const getMemberApplication = (cycleId, userId) =>
  withNotFoundAs(null, async () =>
    mapMemberApplication(await AwardsApi.getMemberApplication(cycleId, userId)));
